/**
 * Logs de depuración ACL (solo desarrollo o VITE_ROUTE_ACL_DEBUG=true).
 */

import { departmentToCode, normalizeRoleName } from './departmentCodes'

export const LOG_PREFIX = '[RouteACL]'

export const ROUTE_ACL_DEBUG =
  import.meta.env.DEV || import.meta.env.VITE_ROUTE_ACL_DEBUG === 'true'

/**
 * @param {string} level
 * @param {string} message
 * @param {unknown} [data]
 */
export function logAcl(level, message, data) {
  if (!ROUTE_ACL_DEBUG) return
  const fn = level === 'warn' ? console.warn : level === 'error' ? console.error : console.log
  if (data !== undefined) {
    fn(`${LOG_PREFIX} ${message}`, data)
  } else {
    fn(`${LOG_PREFIX} ${message}`)
  }
}

/**
 * @param {object | null | undefined} userData
 * @returns {{ keys: string[], unmapped: { department: string, role: string, factory?: string }[] }}
 */
export function buildRoleKeyDebugInfo(userData) {
  const detail = userData?.organization?.roles_detail
  const keys = []
  const unmapped = []

  if (!Array.isArray(detail)) {
    return { keys, unmapped }
  }

  detail.forEach((row) => {
    const deptCode = departmentToCode(row?.department)
    const role = normalizeRoleName(row?.role)
    if (deptCode && role) {
      keys.push(`${deptCode}:${role}`)
    } else {
      unmapped.push({
        factory: row?.factory,
        department: row?.department,
        role: row?.role,
      })
    }
  })

  return { keys, unmapped }
}

/** @deprecated Sin bypass; siempre false. */
export function getBypassReason() {
  return { bypass: false, reason: null }
}
